import {
    useEffect,
    useState
} from "react";
import {useAuth} from "react-oidc-context";
import {GameCard} from "./GameCard";
import {Header} from "./Header";
import {SearchHeader} from "./Search";
import {BASE_URL} from "../constants";
import {useSearchParams} from "react-router-dom";

export interface Game{
    id: number
    image: string
    name: string
    year: string
    min_players: number
    max_players: number
    min_playtime: number
    max_playtime: number
    playing_time: number
    is_expansion: boolean
    loaded: boolean
    owned: boolean
    description: string
    parent_game: []
    expansions: []
    status: number
    painted: boolean
    insert: boolean
    owners:[]
}

export default function Home() {
  const base_url = BASE_URL; //process.env.NEXT_PUBLIC_SERVICE_HOST;
  const auth = useAuth();

  const [cardData, setCardData] = useState<Game[]>([]);
  const [displayGames, setDisplayGames] = useState<Game[]>([]);
  const [userGameDetails, setUserGameDetails] = useState<Game[]>([]);
  const [userFriendGameDetails, setUserFriendGameDetails] = useState<Game[]>([]);
  const [loading, setLoading] = useState(false);
  const [userGames, setUserGames] = useState<number[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const getPathParam = ((paramName:string, default_value:string) => {
    let return_value:string = default_value;
    if (searchParams.has(paramName)) {
        return_value = String(searchParams.get(paramName));
    }
    return return_value;
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [expansions_chk, setExpansions_chk] = useState( getPathParam("filter_expansions", "false")=== 'true');
  const [selectedStatus, setSelectedStatus] = useState(parseInt(getPathParam("filter_status","-1")));
  const [selectedPlayerCount, setSelectedPlayerCount] = useState(parseInt(getPathParam("filter_player_count","-1")));
  const [selectedLetter, setSelectedLetter] = useState(parseInt(getPathParam("filter_letter","-1")));
  const [selectedPaint, setSelectedPaint] = useState(parseInt(getPathParam("filter_painted","-1")));
  const [selectedInsert, setSelectedInsert] = useState(parseInt(getPathParam("filter_inserted","-1")));
    const [friendGames, setFriendGames] = useState(false);
  const [refreshToggle, setRefreshToggle] = useState(true);

    const loadGame = (gameId:number) =>{
      // fetch(`${base_url}/games?gameId=${gameId}`)
      //     .then((response) => response.json())
      //     .then((responseData) => {
      //         cardData.forEach((game: Game) => {
      //             if (game.id === gameId) {
      //               game.loaded = true;
      //               game.image = responseData.image;
      //               game.min_players = responseData.min_players;
      //               game.max_players = responseData.max_players;
      //               game.max_playtime = responseData.max_playtime;
      //               game.playing_time = responseData.playing_time;
      //               game.is_expansion = responseData.is_expansion;
      //               game.status = -1
      //               setRefreshToggle(!refreshToggle);
      //             }
      //         })
      //     }).catch((error) => {
      //     console.error(error);
      // });
  }

  const loadUserGames = () => {
      const sorted: Game[] =userGameDetails.sort((a : Game, b : Game) => {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);});
      setUserGameDetails(sorted);
      showResults(userGameDetails);
      setFriendGames(false);
  }
    const loadFriendGames = () => {
        fetch(`${base_url}/users/${auth.user?.profile.sub}/friends`)
            .then((response) => {
                    return response.json();
                }
            ).then((data) => {
            if (data == null) {
                console.log("user friends not found");
            } else {
                setUserFriendGameDetails(data);
                showResults(data);
                setFriendGames(true);
                setRefreshToggle(!refreshToggle);
            }
        }).catch((fetchError) => {
            console.error(fetchError);
        });

    }

  const addGameToCollection = (gameId: number) => {
    const bodyData = cardData.find((game: Game) => {return game.id === gameId});
    if(bodyData){
        fetch(`${base_url}/users/${auth.user?.profile.sub}/games/${gameId}`,{
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(bodyData)
        })
            .then((response) => response.json())
            .then(() => {
                userGames.push(gameId);
                userGameDetails.push(bodyData);
                    setRefreshToggle(!refreshToggle);
            });
        }
    }

    useEffect(() => {
        showResults(displayGames);
    }, [selectedStatus, selectedPlayerCount, expansions_chk, selectedLetter, selectedPaint, selectedInsert]);

    useEffect(() => {
        loadUserGames();
    }, [userGames]);

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    if (!isNaN(parseInt(searchTerm))) {

    } else {
      fetch(`${base_url}/games?name=${searchTerm}`)
        .then((response) => response.json())
        .then((data) => {
            showResults(data);
            setLoading(false);
        }).catch((fetchError) => {
          setLoading(false);
          console.error(fetchError);
        });
    }
  }

  const showResults = (games: Game[]) => {
    setDisplayGames(games);
    let filteredGames: Game[] = games;
    if (!expansions_chk) {
        filteredGames = filteredGames.filter((game: Game) => !game.is_expansion);
    }
      updatePathParam("filter_expansions", ""+expansions_chk);
    if (selectedStatus != -1) {
        filteredGames = filteredGames.filter((game: Game) => game.status === selectedStatus);
    }
      updatePathParam("filter_status", ""+selectedStatus);
    if (selectedPlayerCount != -1) {
        filteredGames = filteredGames.filter((game: Game) => selectedPlayerCount>=game.min_players && selectedPlayerCount<=game.max_players);
    }
      updatePathParam("filter_player_count", ""+selectedPlayerCount);
    if (selectedLetter != -1) {
        const letter = String.fromCharCode(65+selectedLetter);
        console.log(letter);
        filteredGames = filteredGames.filter((game: Game) => game.name.toUpperCase().startsWith(letter));
    }
      updatePathParam("filter_letter", ""+selectedLetter);
    if (selectedPaint != -1) {
        filteredGames = filteredGames.filter((game: Game) => game.painted === (selectedPaint === 1));
    }
      updatePathParam("filter_painted", ""+selectedPaint);
    if (selectedInsert != -1) {
      filteredGames = filteredGames.filter((game: Game) => game.insert === (selectedInsert===1));
    }
      updatePathParam("filter_inserted", ""+selectedInsert);


      setCardData(filteredGames);
  }


    const updatePathParam = ((paramName:string, value:string) => {
      if (value === "-1"){
          searchParams.delete(paramName);
          setSearchParams(searchParams);
      } else {
          searchParams.set(paramName, value);
          setSearchParams(searchParams);
      }
      setSearchParams(searchParams);
    });

  return (
    <div>
        <header>
            <Header setUserGames={setUserGames} setUserGameDetails={setUserGameDetails} />
            <SearchHeader handleSearch={handleSearch} searchTerm={searchTerm} setSearchTerm={setSearchTerm} expansions_chk={expansions_chk} setExpansions_chk={setExpansions_chk}
                          loadUserGames={loadUserGames} selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus}
                          selectedPlayerCount={selectedPlayerCount} setSelectedPlayerCount={setSelectedPlayerCount}
                          loadFriendGames={loadFriendGames}
                          selectedLetter={selectedLetter} setSelectedLetter={setSelectedLetter}
                          selectedInsert={selectedInsert} setSelectedInsert={setSelectedInsert}
                          selectedPaint={selectedPaint} setSelectedPaint={setSelectedPaint}
                          friendGames={friendGames}
            />
        </header>
        <main className="flex min-h-svh flex-col items-center justify-between p-5 md:p-24 pt-0">
        {loading && <p>Loading...</p>}
            <p className="font-bold p-2" >Showing {cardData.length} of {displayGames.length} results</p>
        {cardData && <div id="card-grid" className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {cardData.map((game: Game) => (
            <GameCard key={game.id} showExpansions={expansions_chk} game={game} authenticated={auth.isAuthenticated} owned={userGames.includes(game.id)} addGameToCollection={addGameToCollection} loadGame={loadGame} friendGames={friendGames}/>
        ))}
    </div>
}
</main>
        <footer>
            <img src="https://cf.geekdo-images.com/HZy35cmzmmyV9BarSuk6ug__thumb/img/gbE7sulIurZE_Tx8EQJXnZSKI6w=/fit-in/200x150/filters:strip_icc()/pic7779581.png" className="w-48 m-auto rounded-2xl bg-white" />
        </footer>
</div>
)
    ;
}
